import { Avatar, Card, CardContent, Grid } from '@material-ui/core';
import { DeleteOutline, Edit, LocationOnOutlined } from '@material-ui/icons';
import classNames from 'classnames';
import { Toggle } from 'components/forms/';
import Text from 'components/text';
import { autobind } from 'core-decorators';
import { reverse } from 'core/urls';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.css';

@autobind
export default class AddressCard extends Component {
    static propTypes = {
        address: PropTypes.object.isRequired,
        selected: PropTypes.bool,
        onChange: PropTypes.func,
        onDelete: PropTypes.func,
        onBlur: PropTypes.func,
    }

    handleDelete() {
        if (window.confirm('¿Realmente querés eliminar esta dirección?')) {
            this.props.onDelete(this.props.address.id);
        }
    }

    handleClick() {
        if (this.props.onChange) this.props.onChange(this.props.selected ? '' : this.props.address.id);
        if (this.props.onBlur) this.props.onBlur();
    }

    render() {
        const {id, name, street, postalCode, locality, phone, lat, lng, notes} = this.props.address;

        return (
            <Card
                elevation={0}
                className={classNames(styles.root, {
                    [styles.selectable]: this.props.onChange,
                    [styles.selected]: this.props.selected,
                })}
                onClick={this.handleClick}>
                <CardContent className={styles.body}>
                    <Grid container alignItems='center'>
                        <Grid item xs={9}>
                            <Grid container spacing={2} justify='flex-start' alignItems='center'>
                                <Grid item>
                                    <Avatar className={styles.geoAvatar}>
                                        <LocationOnOutlined className={styles.geo} />
                                    </Avatar>
                                </Grid>
                                <Grid item>
                                    {name && <Text className={styles.name}>{name}</Text>}
                                    <Text>{street} ({postalCode})</Text>
                                    <Text>{locality.label}</Text>
                                    {lat && lng && <Text>GPS: {lat}, {lng}</Text>}
                                    <Text>{phone}</Text>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={3}>
                            <Grid container spacing={2} justify='flex-end' alignItems='center'>
                                {!this.props.onChange && (
                                    <div className={styles.buttonContainer} >
                                        <Grid item xs={6} className={styles.avatarContainer}>
                                            <Link to={reverse('updateAddress', {id})}>
                                                <Avatar className={styles.avatar}><Edit /></Avatar>
                                            </Link>
                                        </Grid>
                                        {this.props.onDelete && (
                                            <Grid item xs={6} className={styles.avatarContainer}>
                                                <Avatar className={styles.delete} onClick={this.handleDelete}>
                                                    <DeleteOutline />
                                                </Avatar>
                                            </Grid>
                                        )}
                                    </div>
                                )}
                                {this.props.onChange && (
                                    <Grid item style={{paddingRight: '20px'}}>
                                        <Toggle type='radio' value={this.props.address.isDefault} readOnly />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./components/address-grid/address-card/index.js